<template>
    <div style="display: inline-block">
        <r-button :type="triggerType" :size="triggerSize" @click="showModal">{{triggerTitle}}</r-button>
        <v-modal v-if="isModalVisible" :title="modalTitle" @close="closeModal" @submit="submit">
            <template slot="content">
                <v-error-messages
                    :has-frontend-errors="$v.$error"
                    class="stack-l">
                    <li class="list-item" v-if="!$v.selectedStartTime.mustBeValidDate">Start time must be a valid date</li>
                    <li class="list-item" v-if="!$v.selectedEndTime.mustBeValidDate">End time must be a valid date</li>
                    <li class="list-item" v-else-if="!$v.selectedEndTime.mustBeGreaterThanStartTime">End time must greater than start time</li>
                </v-error-messages>
                <p class="text-muted stack-m">Set the <strong>Start time</strong> to begin the downtime gateway period. The gateway will be set back to normal on <strong>End time</strong>.</p>
                <v-date-input
                    label="Start time"
                    type="datetime"
                    class="stack-m"
                    :validate="$v.selectedStartTime"
                    v-model="selectedStartTime"/>
                <v-date-input
                    label="End time"
                    type="datetime"
                    :validate="$v.selectedEndTime"
                    v-model="selectedEndTime"/>
            </template>
            <template slot="actions">
                <r-button type="primary" @click="submit">Save</r-button>
            </template>
        </v-modal>
    </div>
</template>

<script>
    import vModal from '@/components/modal/v-modal';
    import {vErrorMessages, vDateInput} from '@/components/form/index';
    import GatewayAccountDowntimeModel from '@/common/models/gateway-account-downtime-model';

    export default {
        name: 'gateway-downtime-form-modal',
        components: {
            vDateInput,
            vModal,
            vErrorMessages,
        },
        props: {
            triggerTitle: {
                type: String,
                default: 'Edit',
            },
            modalTitle: {
                type: String,
                default: 'Edit downtime schedule',
            },
            triggerSize: {
                type: String,
            },
            triggerType: String,
            value: Object,
        },
        data() {
            return {
                isModalVisible: false,
                selectedStartTime: null,
                selectedEndTime: null,
            };
        },
        validations: {
            selectedStartTime: {
                mustBeValidDate(date) {
                    return date.isValid();
                },
            },
            selectedEndTime: {
                mustBeValidDate(date) {
                    return date.isValid();
                },
                mustBeGreaterThanStartTime(date) {
                    return +date > +this.selectedStartTime;
                },
            },
        },
        methods: {
            initialStartTime() {
                if (this.value && this.value.startTime) {
                    return this.$tz().readUTC(this.value.startTime);
                }
                return this.$tz().now().add(5, 'minutes');
            },
            initialEndTime() {
                if (this.value && this.value.endTime) {
                    return this.$tz().readUTC(this.value.endTime);
                }
                return this.initialStartTime().add(1, 'hours');
            },
            showModal() {
                this.selectedStartTime = this.initialStartTime();
                this.selectedEndTime = this.initialEndTime();
                this.isModalVisible = true;
            },
            closeModal() {
                this.isModalVisible = false;
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    const initialParams = (this.value && {...this.value}) || {};
                    const dateTimeParams = {
                        startTime: this.selectedStartTime.format(),
                        endTime: this.selectedEndTime.format(),
                    };
                    this.$emit('submit', new GatewayAccountDowntimeModel({...initialParams, ...dateTimeParams}));
                    this.closeModal();
                }
            },
        },
    };
</script>
